import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { navItems, resolveActiveNavId } from './navItems';

/**
 * Recomputes the active nav-item id once per location change. Uses the
 * longest-prefix matcher in `navItems.resolveActiveNavId`, identical to
 * the support app's `_active_nav_id` Jinja helper.
 */
export function useActiveNavId(): string | null {
  const { pathname } = useLocation();
  return useMemo(() => resolveActiveNavId(navItems, pathname), [pathname]);
}

export default useActiveNavId;
